import React, { useCallback } from 'react';

import { isEmpty } from 'lodash';

export const InputCodeField = ({
  setCode,
  currencyValue,
  loading,
  startInput,
  modalId,
  onSubmit
}) => {
  const handleClick = event => {
    if (event && event.key === 'Backspace') {
      const { id, value } = event.target;
      const nextInputId = value === '' ? +id[1] - 1 : +id[1];
      const nextInput = document.getElementById(`d${nextInputId}`);
      nextInput && nextInput.focus();
    }

    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  const handleChange = useCallback(
    event => {
      const { id, value } = event.target;
      if (['d1', 'd2', 'd3', 'd4', 'd5', 'd6'].includes(id)) {
        const nextInputId = +id[1] + 1;
        const domElement = !!modalId
          ? document.getElementById(modalId)
          : document;
        const nextInput = domElement?.querySelector(`#d${nextInputId}`);
        setCode(id, value);
        if (!isEmpty(value)) {
          nextInput && nextInput.focus();
        }
      }
    },
    [setCode]
  );

  const handlePaste = useCallback(
    event => {
      event.preventDefault();
      const pastedText = event.clipboardData.getData('Text');
      if (pastedText.length === 6) {
        for (let i = 1; i <= pastedText.length; i++) {
          setCode('d' + i, pastedText[i - 1]);
        }
        const nextInput = document.getElementById(`d6`);
        nextInput && nextInput.focus();
      }
    },
    [setCode]
  );

  return (
    <div className={'code-inp-container'} onPaste={handlePaste}>
      <input
        className="form-input code-inp mb-2"
        autoFocus
        id="d1"
        value={currencyValue.d1}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
      <input
        className="form-input code-inp mb-2"
        id="d2"
        value={currencyValue.d2}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
      <input
        className="form-input code-inp mb-2"
        id="d3"
        value={currencyValue.d3}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
      <input
        className="form-input code-inp mb-2"
        id="d4"
        value={currencyValue.d4}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
      <input
        className="form-input code-inp mb-2"
        id="d5"
        value={currencyValue.d5}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
      <input
        className="form-input code-inp mb-2"
        id="d6"
        value={currencyValue.d6}
        type="text"
        maxLength={1}
        disabled={loading}
        onChange={handleChange}
        itemRef={startInput}
        onKeyDown={handleClick}
        pattern="\d*" 
        inputmode="numeric"
      />
    </div>
  );
};
